import React, { useEffect } from "react";
import { isPlatform } from "@ionic/react";
import { useHistory } from "react-router-dom";
import { Plugins } from "@capacitor/core";
const { App: CapApp } = Plugins;

const AppUrlListener: React.FC<any> = (props: any) => {
	let history = useHistory();
	useEffect(() => {
		// console.log("DEEP LINKING .. WORKS === Platform check === ", isPlatform("desktop"));
		// if (!isPlatform("desktop")) {
		// console.log("DEEP LINKING .. WORKS");
		// CapApp.addListener("appUrlOpen", (data: any) => {
		// console.log("DEEP LINKING .. WORKS >>> ", data);
		// Example url: https://beerswift.app/tabs/tab2
		// slug = /tabs/tab2
		// const slug = data.url.split(".app").pop();
		// if (slug) {
		//   history.push("/portal");
		// props.history.push("/portal/book_service");
		// }
		// If no match, do nothing - let regular routing
		// logic take over
		// });
		// } else {
		//   console.log("Deep linking not required");
		// }
	}, []);

	return null;
};

export default AppUrlListener;
